var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"result"},[_c('img',{staticClass:"success-icon",attrs:{"src":require("@static/images/fail.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("请在企业微信内打开当前链接")])])])
}]

export { render, staticRenderFns }